<template>
  <div :class="['mx-catalog', hasMargin && 'has-margin']" :style="{ backgroundColor: backgroundColor }">
    <img class="avatar-icon" v-if="!!avatarIcon" src="avatarIcon" alt="*" />
    <slot>
      {{ title }}
    </slot>
  </div>
</template>

<script>
export default {
  name: 'mx-catalog',
  props: {
    title: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: '#f9f9f9',
    },
    textColor: {
      type: String,
      default: '#8a8a8f',
    },
    avatarIcon: {
      type: String,
      default: '',
    },
    hasMargin: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {};
  },

  methods: {},
};
</script>
